module.exports = __webpack_public_path__ + "static/strokeweight-060-80b2960a4f29a59dd2faa461e5eac472.woff2";